import React from 'react';
import { Form } from 'react-bootstrap';
import { connect } from 'react-redux';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';

import Column from './base.jsx';

import { setAssetQuantity } from '../../../Store/portfolio.js';


const columnOptions = {
  id: 'o',
  title: 'Held Amount'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get overlayText() {
    return 'Enter your holdings in the boxes below. No need to save, we\'ll do that for you';
  }
}


class DetailColumn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.row.heldAmount || ''
    }

    this.onChange = this.onChange.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    // if change portfolio, reset the value
    if (prevProps.row.heldAmount !== this.props.row.heldAmount) {
      this.setState({
        value: this.props.row.heldAmount || ''
      });
    }

    //if value of assets changes, update the quantity
    if (prevState.value !== this.state.value) {
      const value = parseFloat(this.state.value || 0);
      if (!isNaN(value) && value >= 0) {
        this.props.updateAssetQuantity(value);
      }
    }
  }

  /**
   * Handle input changes, allowing only valid numeric input
   */
  onChange(event) {
    let value = event.target.value.trim();

    // Allow empty string (for clearing the input)
    if (value === "") {
      this.setState({ value: "" });
      return;
    }

    // check if the value is a valid number
    const valueParse = parseFloat(value);
    if (!isNaN(valueParse) && valueParse >= 0) {
      // Remove unnecessary leading zeroes unless it's "0." or "0"
      if (value.startsWith("0") && value !== "0" && !value.startsWith("0.")) {
        value = valueParse.toString();
      }

      this.setState({ value });
    }
  }

  render() {
    return (
      <td>
        <Form.Control
          size="sm"
          name="amount"
          type="number"
          min="0"
          id={'amount-' + this.props.row.id}
          value={this.state.value}
          onChange={this.onChange}
          className="form-control--text"
        />
      </td>
    );
  }
}


var mapDispatchToProps = function(dispatch, ownProps) {
  return {
    updateAssetQuantity: function(quantity) {
      dispatch(setAssetQuantity(ownProps.row.id, quantity, ownProps.row.portfolioId));
    }
  };
};


DetailColumn = connect(null, mapDispatchToProps)(DetailColumn);


class HeldAmount extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.heldAmount < b.heldAmount) {
      return -1;
    }
    if (a.heldAmount > b.heldAmount) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.heldAmount < b.heldAmount) {
      return 1;
    }
    if (a.heldAmount > b.heldAmount) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default HeldAmount;

